module.exports = ".com-recovery-password {\n  align-items: center;\n  display: flex;\n  min-height: 100vh;\n}"